import React, { Component } from 'react';
import { connect } from 'react-redux'
import { noVolume, noMircrophone, mediumVolume, heightVolume, microphone } from '../../../Images/Images';
import ReactSimpleRange from 'react-simple-range';
import { volumeSpeaker, volumeMicrophone } from '../../../redux/actions/A_volume';
import { INTEGRATION,SOFTPHONES_KEY } from '../../../constants';
import { SingletonSharedData } from '../../../js/singletonSharedData';
class VolumeWindow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      speakerVolume: this.props.volSpeaker,
      lastSpeakerVolume: this.props.volSpeaker,
      microphoneVolume: this.props.muteMicrophone ? 0 : this.props.volMicrophone,
      lastMicrophoneVolume: this.props.muteMicrophone ? 0 : this.props.volMicrophone,
      muteMicrophone: this.props.muteMicrophone,
      pointerVolume: 0,
      disabledVolume: false
    };
    this.timerVol = {};
    this.imageVolume = mediumVolume;
    this.animVolume = [];
    this.sharedData = new SingletonSharedData();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.messagesIntegrations && nextProps.messagesIntegrations.dataMessageIntegration) {
      let _this = this;
      _this.volumenFromIntegratioin(nextProps.messagesIntegrations.dataMessageIntegration)
    }

    if (!this.state.muteMicrophone && nextProps.muteMicrophone) {
      this.setState({
        lastMicrophoneVolume: this.state.microphoneVolume,
        microphoneVolume: 0,
        muteMicrophone: true
      });
    }
    if (this.state.muteMicrophone && !nextProps.muteMicrophone) {
      let microVol = (this.state.lastMicrophoneVolume === 0 ? 50 : this.state.lastMicrophoneVolume);
      this.setState({
        microphoneVolume: microVol,
        muteMicrophone: false
      });
      this.props.onChangeVolumeMicro(microVol);
    }
  }

  componentWillUnmount() {
    clearInterval(this.timerVol);
  }
  componentDidMount() {
    if (window.chrome && !!window.chrome.webstore && this.sharedData.currentSoftPhone === SOFTPHONES_KEY.WebRTC) {
      this.props.alert(true);
      this.imageVolume = noVolume;
      this.setState({ disabledVolume: true });
    }
    this.animVolume = [5, 4, 3, 2, 1, 0];
    this.timerVolume();
    if (this.props.messagesIntegrations && this.props.messagesIntegrations.dataMessageIntegration) {
      this.volumenFromIntegratioin(this.props.messagesIntegrations.dataMessageIntegration)
    }
  }
  timerVolume() {
    var _this = this;
    this.timerVol = setInterval(() => {
      let baseAnim = (Math.floor(_this.state.microphoneVolume / 33.4) + 1) * 2 - 1;
      let rnd = (Math.floor(Math.random() * 3) + 1) - 2;
      _this.setState({ pointerVolume: baseAnim + rnd });
    }, 250);
  }

  movingSpeaker(props) {
    if (!this.state.disabledVolume) {
      this.setState({ speakerVolume: props.value });
      this.imageVolume = props.value > 50 ? heightVolume : props.value > 0 ? mediumVolume : noVolume;
      this.props.volumeSpeaker(props.value);
      this.props.onChangeVolumeSpeakers(props.value);
    }
  }

  movingMicrophone(props) {
    this.setState({
      microphoneVolume: props.value,
      muteMicrophone: props.value === 0
    });
    this.props.volumeMicrophone(props.value);
    this.props.onChangeVolumeMicro(props.value);
  }

  volumenFromIntegratioin(dataMessageIntegration){
    let _this = this;
    if (dataMessageIntegration.device === INTEGRATION.SPEAKER) {
      _this.movingSpeaker({ value: parseInt(dataMessageIntegration.vol, 10) });
    } else if (dataMessageIntegration.device === INTEGRATION.MICROPHONE) {
      _this.movingMicrophone({ value: parseInt(dataMessageIntegration.vol, 10) });
    }
    setTimeout(() => {
      this.props.closeItem();
    }, 1500);
  }

  render() {
    return (
      <div className="volumeWindow">
        <div className="volumeSpeaker">
          <img src={this.imageVolume} className={"imgVolumeTop " + (this.state.disabledVolume ? "disabled" : "")} alt="icon" />
          <div className="sliderContainer">
            <ReactSimpleRange
              vertical
              value={this.state.disabledVolume ? 50 : this.state.speakerVolume}
              sliderSize={3}
              sliderColor="rgba(255,255,255,0.22)"
              trackColor="blue"
              thumbColor="#B71C1C"
              verticalSliderHeight="100%"
              onChange={this.movingSpeaker.bind(this)}
              max={100}
              min={0}
              disableTrack={this.state.disabledVolume}>
              <div className={"thumbCustom " + (this.state.disabledVolume ? "disabled" : "")}></div>
            </ReactSimpleRange>
          </div>
          <img src={noVolume} className="imgVolumeDown" alt="icon" />
        </div>
        <div className="volumeMicrophone">
          <img src={microphone} className="imgVolumeTop" alt="icon" />
          <div className="microPointsContainer">
            {this.animVolume.map((item) =>
              <div key={item} className={"volumeAnimation " + (this.state.pointerVolume > parseInt(item, 10) && "volumeAnimationActive")}></div>)}
          </div>
          <div className="sliderContainer">
            <ReactSimpleRange className="sliderVolume"
              vertical
              sliderSize={3}
              value={this.state.microphoneVolume}
              sliderColor="rgba(255,255,255,0.22)"
              trackColor="blue"
              thumbColor="#B71C1C"
              verticalSliderHeight="100%"
              onChange={this.movingMicrophone.bind(this)}
            >
              <div className="thumbCustom"></div>
            </ReactSimpleRange>
          </div>
          <img src={noMircrophone} className="imgVolumeDown" alt="icon" />
        </div>
      </div>
    );
  }
};

function mapStateToProps(state) {
  return {
    messagesIntegrations: state.messagesIntegrations
  }
}

function mapDispatchToProps(dispatch) {
  return ({
    volumeSpeaker: (volume) => { dispatch(volumeSpeaker(volume)) },
    volumeMicrophone: (volume) => { dispatch(volumeMicrophone(volume)) },
  })
}

export default VolumeWindow = connect(
  mapStateToProps,
  mapDispatchToProps
)(VolumeWindow);



// WEBPACK FOOTER //
// ./src/components/workSpace/Others/Volume.jsx